const getImageUrl = (image: string): string => {
        return `/images/${image}`;
    }

export default getImageUrl